import * as React from 'react';

/**
 * TODO consider getting rid from wrapper variant
 * @ignore - internal component.
 */
export const WrapperVariantContext = /*#__PURE__*/React.createContext(null);